import { makeStyles } from '@mui/styles';
import { defaultIcon } from '../../default';

const useStyles = makeStyles({
  check: {
    ...defaultIcon,
    width: '.7em',
    height: '0.15em',
    maxHeight: '0.15em',
    borderRadius: '.05em',
    transform: 'translate(-40%, -50%) rotate(-35deg)',
    '&:after, &:before': {
      width: '.4em',
      top: '-.125em',
      left: '-.125em',
      transform: 'rotate(-90deg)',
      borderRadius: '.05em',
    },
    '&:after': {
      top: 'auto',
      width: 0,
      bottom: '-.125em',
      transform: 'rotate(90deg)',
    },
  },
});

export default useStyles;
